import { Box, Card, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Labeled } from 'react-admin';
import { Customer } from '../order/Order.type';
import { toPriceKRW } from '../util/CommonUtils';
import { getCustomerSettlementShow } from './OrderSettlement.api';
import { OrderSettlementType } from './Settlement.type';

export default function CustomerOrderSettlementShow({
  date,
  customer,
}: {
  date?: string;
  customer?: Customer;
}) {
  const [stlmt, setStlmt] = useState<OrderSettlementType>();

  useEffect(() => {
    getCustomerSettlementShow({ date, customerId: customer?.id }).then(
      (res) => {
        setStlmt(res.data);
      }
    );
  }, [date, customer]);

  return (
    <Card>
      <Box sx={{ padding: 2 }}>
        <Typography
          variant='h5'
          display={'inline'}
        >{`${stlmt?.year}년`}</Typography>
        <Typography
          variant='h5'
          display={'inline'}
          marginLeft={1}
        >{`${stlmt?.month}월`}</Typography>
        {customer && (
          <Typography display={'inline'} marginLeft={2} variant='h5'>
            {customer?.name}
          </Typography>
        )}
        <Box>
          <Labeled
            label={`총 수량`}
            children={<>{stlmt?.totalAmountForMonth || 0}</>}
          />
        </Box>
        <Box>
          <Labeled
            label={`합산 금액`}
            children={<>{toPriceKRW(stlmt?.totalDisplayGrossPrice)}</>}
          />
        </Box>
      </Box>
    </Card>
  );
}
